// extracted by css-extract-rspack-plugin
var _1 = "Namw8csQ6n1rw0n26lZtuw--";
export { _1 as "interop" }
